<div class="about-area-start rts-section-gapBottom" id="why-choose">
  <div class="container">
    <div class="row align-items-center">
      <div class="col-xl-6 col-lg-12">
        <div class="about-one-left-image">
          <div class="first-order">
            <div class="thumb-bottom">
              <img src="assets/images/about/02.jpg" alt="about" />
            </div>
          </div>
          <div class="second-order">
            <img src="assets/images/about/01.jpg" alt="about" />
            <div class="vedio-icone">
              <a
                class="video-play-button play-video popup-video"
                href="https://www.youtube.com/watch?v=cp_l8PCZrM0"
              >
                <span></span>
              </a>
              <div class="video-overlay">
                <a class="video-overlay-close">×</a>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        class="col-xl-6 col-lg-12 pl--60 pl_lg--15 pl_md--10 pl_sm--10 pt_lg--50 pt_md--50 pt_sm--50"
      >
        <div class="title-area-left-style">
          <h2 class="title">Por que escolher a Faculdade FACINT?</h2>
          <p class="post-title">
            Na FACINT, somos apaixonados por educação e comprometidos em
            oferecer materiais de aprendizado de alta qualidade para nossos
            estudantes. Aqui, você encontra oportunidades reais de crescimento,
            com ensino acessível, atualizado e conectado com o mercado.
          </p>
        </div>
        <div class="about-inner-right-one">
          <div class="what-you-get">
            <div class="single-facilityes">
              <div class="information">
                <h5 class="title">Metodologia Inovadora</h5>
                <p>
                  Aprenda de forma prática, dinâmica e conectada com o mercado.
                </p>
              </div>
            </div>

            <div class="single-facilityes">
              <div class="information">
                <h5 class="title">Equipe Multidisciplinar</h5>
                <p>
                  Professores experientes de diversas áreas, prontos para te
                  guiar.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
